import { Component, EventEmitter, inject, Input, OnInit } from '@angular/core';
import {SvgIconComponent} from "../../svg-icon/svg-icon.component";
import {HasCloseEvent} from "../../../interfaces/has-close-event.interface";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {GalleryService} from "../../../services/gallery.service";
import {ImageModel} from "../../../models/image.model";
import {IconButtonComponent} from "../../icon-button/icon-button.component";
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-image-gallery',
  standalone: true,
  imports: [
    SvgIconComponent,
    NgIf,
    NgClass,
    NgForOf,
    IconButtonComponent,
    TranslocoDirective
  ],
  templateUrl: './image-gallery.component.html',
  styleUrl: './image-gallery.component.scss'
})
export class ImageGalleryComponent implements HasCloseEvent, OnInit {
  @Input() public data: ImageModel[] = []
  @Input() public readonly: boolean = false;
  public selected: number = 0;
  public selectedChange: EventEmitter<number> = new EventEmitter<number>();
  public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected galleryService = inject(GalleryService);

  ngOnInit() {
    this.galleryService.selected.subscribe((value: number) => this.selected = value);
    this.galleryService.images = [...this.data];
  }

  protected prev(): void {
    this.selected = Math.max(0, this.selected - 1);
    this.galleryService.selected.next(this.selected);
  }

  protected next(): void {
    this.selected = Math.min(this.galleryService.images.length - 1, this.selected + 1);
    this.galleryService.selected.next(this.selected);
  }

  protected select(index: number): void {
    this.selected = index;
    this.galleryService.selected.next(this.selected);
  }

  protected deleteImage() {
    let imageIdToDelete = this.galleryService.images[this.selected--].id;
    this.galleryService.deleteImage(imageIdToDelete)
    this.selected = Math.max(0, this.selected)
  }

  protected displayCreatedAt(): string {
    const pad = (num: number) => String(num).padStart(2, '0');
    let d = new Date(this.galleryService.images[this.selected].createdAt ?? new Date());
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

  }
}
